export enum BiomeID {
  SnowyVillage = 'snowy_village',
  FrozenDepths = 'frozen_depths',
  //KrampusLair = 'krampus_lair',
}
